import { useCheckoutAnalytics } from './hooks/useCheckoutAnalytics';
import { useCheckoutPage } from './hooks/useCheckoutPage';
import { useCheckoutPayments } from './hooks/useCheckoutPayments';
import { usePaymentCompletion } from './hooks/usePaymentCompletion';
import { CheckoutPageView } from './views/CheckoutPageView';

export default function Checkout() {
  const checkout = useCheckoutPage();

  useCheckoutAnalytics(checkout.planForDisplay, checkout.currency);

  const paymentCompletion = usePaymentCompletion({
    valuesRef: checkout.valuesRef,
    chargeIdRef: checkout.chargeIdRef,
    plan: checkout.planForDisplay,
    currency: checkout.currency,
    isStripe: checkout.isStripe,
  });

  const payment = useCheckoutPayments({
    valuesRef: checkout.valuesRef,
    chargeIdRef: checkout.chargeIdRef,
    plan: checkout.planForDisplay,
    currency: checkout.currency,
    buyerCountry: checkout.selectedCountry,
    setPixInfo: checkout.setPixInfo,
    showError: checkout.setSnackbar,
    ...paymentCompletion,
  });

  return <CheckoutPageView checkout={checkout} payment={payment} />;
}
